<template>
    <div>
        <div class="row mb-2">
            <b-card class="col-sm-12 col-md-6 col-lg-6 col-xl mx-sm-1 mx-md-0 mx-lg-0 mx-xl-1 mx-1">
                <b-card-title title-tag="h5" class="lh-1" title="Lifetime Plays"></b-card-title>
                <b-card-text class="row" text-tag="div">
                    <b-badge
                        pill
                        variant="success"
                        class="bgc-green-50 c-green-500 d-ib va-m pull-right p-3 metric-pill fw-600 lh-0 bdrs-10em peer ml-auto"
                    >{{ lifeTimeBookings }}</b-badge>
                </b-card-text>
            </b-card>
            <b-card class="col-sm-12 col-md-6 col-lg-6 col-xl mx-sm-1 mx-md-0 mx-lg-0 mx-xl-1 mx-1">
                <b-card-title title-tag="h5" class="lh-1" title="Future Bookings"></b-card-title>
                <b-card-text class="row" text-tag="div">
                    <b-badge
                        pill
                        variant="success"
                        class="bgc-red-50 c-red-500 d-ib va-m pull-right p-3 metric-pill fw-600 lh-0 bdrs-10em peer ml-auto"
                    >{{ totalFutureBookings }}</b-badge>
                </b-card-text>
            </b-card>
            <b-card class="col-sm-12 col-md-6 col-lg-6 col-xl mx-sm-1 mx-md-0 mx-lg-0 mx-xl-1 mx-1">
                <b-card-title title-tag="h5" class="lh-1" title="Total Members"></b-card-title>
                <b-card-text class="row" text-tag="div">
                    <b-badge
                        pill
                        variant="success"
                        class="bgc-purple-50 c-purple-500 d-ib va-m pull-right p-3 metric-pill fw-600 lh-0 bdrs-10em peer ml-auto"
                    >{{ totalMembers }}</b-badge>
                </b-card-text>
            </b-card>
            <b-card class="col-sm-12 col-md-6 col-lg-6 col-xl mx-sm-1 mx-md-0 mx-lg-0 mx-xl-1 mx-1">
                <b-card-title title-tag="h5" class="lh-1" title="Total Rentals"></b-card-title>
                <b-card-text class="row" text-tag="div">
                    <b-badge
                        pill
                        variant="success"
                        class="bgc-blue-50 c-blue-500 d-ib va-m pull-right p-3 metric-pill fw-600 lh-0 bdrs-10em peer ml-auto"
                    >{{ totalRentals }}</b-badge>
                </b-card-text>
            </b-card>
            <b-card @click="seeMarshalNotes" class="cursor-pointer col-sm-12 col-md-6 col-lg-6 col-xl mx-sm-1 mx-md-0 mx-lg-0 mx-xl-1 mx-1">
                <b-card-title title-tag="h5" class="lh-1" title="Unseen Marshal Notes"></b-card-title>
                <b-card-text class="row" text-tag="div">
                    <template v-if="unseenNoteCount > 0">
                        <small class="text-muted mt-auto ml-3" style="font-size: 0.6em !important;">(Click To View)</small>
                    </template>
                    <b-badge
                        pill
                        variant="success"
                        class="bgc-orange-50 c-orange-500 d-ib va-m pull-right p-3 metric-pill fw-600 lh-0 bdrs-10em peer ml-auto"
                    >{{ unseenNoteCount }}</b-badge>
                </b-card-text>
            </b-card>
        </div>

        <div v-if="memberRatio.member && totalMembers" class="row px-1 mb-2">
            <b-card class="col-12">
                <b-card-title title="Member to Player Ratio"></b-card-title>
                <b-card-sub-title
                    :sub-title="'Total Players: ' + totalMembers + ' / Total Members: ' + memberRatio.member"
                ></b-card-sub-title>
                <b-card-text text-tag="div">
                    <h5 class="text-right">{{ Math.round((memberRatio.member / totalMembers) * 100) }}%</h5>
                    <b-progress style="height: 5px;" :value="memberRatio.member" :max="totalMembers"></b-progress>
                </b-card-text>
            </b-card>
        </div>

       <div class="row px-1 mb-2" role="tablist">
            <b-card v-if="noUkara" no-body class="col-12 mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-1 variant="primary">No Ukara ({{ noUkara.length }})</b-button>
                </b-card-header>
                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel" @shown="noUkaraShow()">
                    <b-card-body>
                        <b-card-text text-tag="div" id="no-ukara-table"></b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card v-if="unverifiedEmails" no-body class="col-12 mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-2 variant="primary">Unverified Emails ({{ unverifiedEmails.length }})</b-button>
                </b-card-header>
                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel" @shown="unverifiedShow()">
                    <b-card-body>
                        <b-card-text text-tag="div" id="unverified-table"></b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card v-if="waiverRequired" no-body class="col-12 mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-3 variant="primary">Waiver Upload Required ({{ waiverRequired.length }})</b-button>
                </b-card-header>
                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel" @shown="waiverRequiredShow()">
                    <b-card-body>
                        <b-card-text text-tag="div" id="waiver-required-table"></b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card v-if="jailUsers" no-body class="col-12 mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-4 variant="primary">30 Day No Shows ({{ jailUsers.length }})</b-button>
                </b-card-header>
                <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel" @shown="jailUserShow()">
                    <b-card-body>
                        <b-card-text text-tag="div" id="jail-users-table"></b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
            <b-card v-if="noShowUsers" no-body class="col-12 mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-5 variant="primary">Lifetime No Shows ({{ noShowUsers.length }})</b-button>
                </b-card-header>
                <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel" @shown="noShowUsersShow()">
                    <b-card-body>
                        <b-card-text text-tag="div" id="no-show-table"></b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>

        <div v-if="($hasRole('Admin') || $hasRole('SuperAdmin')) && (chartData || playerData)" class="row px-1 mb-2">
            <b-card v-if="chartData" class="col-6">
                <b-card-title title="Monthly Income"></b-card-title>
                <b-card-text text-tag="canvas" class="col" id="incomeChart" ref="incomeChart"></b-card-text>
            </b-card>

            <b-card v-if="playerData" class="col-6">
                <b-card-title title="Monthly Player Count"></b-card-title>
                <b-card-text text-tag="canvas" class="col" id="playerChart" ref="playerChart"></b-card-text>
            </b-card>
        </div>

        <marshal-notes-modal :show="showMarshalNotesModal" :notes="unseenNoteBookings" @closing="unseeMarshalNotes"></marshal-notes-modal>
    </div>
</template>

<script>
import Bar from "chart.js";

export default {
    props: {
        sites: {default: false}
    },
    data() {
        return {
            lifeTimeBookings: 0,
            totalFutureBookings: 0,
            totalPlayers: 0,
            totalMembers: 0,
            totalRentals: 0,
            memberRatio: {
                none: 0,
                member: 0,
            },
            chartData: false,
            playerData: false,
            noUkara: false,
            noUkaraTable: false,
            expUkara: false,
            expUkaraTable: false,
            expiringMember: false,
            expiringMemberTable: false,
            expiredMember: false,
            expiredMemberTable: false,
            expiringWaivers: false,
            expiringWaiversTable: false,
            expiredWaivers: false,
            expiredWaiversTable: false,
            unverifiedEmails: false,
            unverifiedEmailsTable: false,
            waiverRequired: false,
            waiverRequiredTable: false,
            jailUsers: false,
            jailUsersTable: false,
            noShowUsers: false,
            noShowUsersTable: false,
            unseenNoteCount: 0,
            unseenNoteBookings: [],
            showMarshalNotesModal: false,
        };
    },
    methods: {
        seeMarshalNotes() {
            this.showMarshalNotesModal = true;
        },
        unseeMarshalNotes() {
            this.showMarshalNotesModal = false;
        },
        noUkaraShow() {
            setTimeout(() => {
                this.noUkaraTable = new Tabulator("#no-ukara-table", {
                    pagination: "local",
                    paginationSize: 10,
                    initialSort: [
                        { column: "forename", dir: "asc" },
                    ],
                    data: this.noUkara,
                    layout: "fitColumns",
                    columns: [
                        { title: "Name", field: "forename", formatter: (cell) => {
                            let data = cell.getData();
                            return data.forename.capitalize() + " " + data.surname.capitalize();
                        }},
                        { title: "Member Number", field: "member_number" },
                    ],
                    rowClick: function(e, row) {
                        location.replace("/member/" + row.getData().id);
                    }
                });
            }, 10);
        },
        unverifiedShow() {
            setTimeout(() => {
                this.unverifiedEmailsTable = new Tabulator("#unverified-table", {
                    pagination: "local",
                    paginationSize: 10,
                    initialSort: [
                        { column: "forename", dir: "asc" },
                    ],
                    data: this.unverifiedEmails,
                    layout: "fitColumns",
                    columns: [
                        { title: "Name", field: "forename", formatter: (cell) => {
                            let data = cell.getData();
                            return data.forename.capitalize() + " " + data.surname.capitalize();
                        }},
                    ],
                    rowClick: function(e, row) {
                        location.replace("/member/" + row.getData().id);
                    }
                });
            }, 10);
        },
        waiverRequiredShow() {
            setTimeout(() => {
                this.waiverRequiredTable = new Tabulator("#waiver-required-table", {
                    pagination: "local",
                    paginationSize: 10,
                    initialSort: [
                        { column: "forename", dir: "asc" },
                    ],
                    data: this.waiverRequired,
                    layout: "fitColumns",
                    columns: [
                        { title: "Name", field: "forename", formatter: (cell) => {
                            let data = cell.getData();
                            return data.forename.capitalize() + " " + data.surname.capitalize();
                        }},
                        {
                            title: "Member Number",
                            field: "member_number",
                        },
                    ],
                    rowClick: function(e, row) {
                        location.replace("/member/" + row.getData().id);
                    }
                });
            }, 10);
        },
        expUkaraShow() {
            setTimeout(() => {
                this.expUkaraTable = new Tabulator("#exp-ukara-table", {
                    pagination: "local",
                    paginationSize: 10,
                    initialSort: [{ column: "ukara_expiry", dir: "desc" }],
                    data: this.expUkara,
                    layout: "fitColumns",
                    columns: [
                        { title: "Name", field: "name" },
                        {
                            title: "Expiring",
                            field: "ukara_expiry",
                            sorter: "date",
                            sorterParams: { format: "YYYY/MM/DD" },
                            formatter: function(cell) {
                                var data = cell.getData();
                                var exp = new moment(data.ukara_expiry);

                                if (data.ukara) {
                                    return exp.format("DD/MM/YYYY");
                                } else {
                                    return "N/A";
                                }
                            }
                        }
                    ],
                    rowClick: function(e, row) {
                        location.replace("/member/" + row.getData().id);
                    }
                });
            }, 10);
        },
        expiringMembersShow() {
            setTimeout(() => {
                this.expiringMemberTable = new Tabulator(
                    "#expiring-members-table",
                    {
                        pagination: "local",
                        paginationSize: 10,
                        initialSort: [{ column: "member_expiry", dir: "asc" }],
                        data: this.expiringMember,
                        layout: "fitColumns",
                        columns: [
                            { title: "Name", field: "name" },
                            { title: "Member Level", field: "level" },
                            {
                                title: "Expiring",
                                field: "member_expiry",
                                sorter: "date",
                                sorterParams: { format: "YYYY/MM/DD" },
                                formatter: function(cell) {
                                    var data = cell.getData();
                                    var exp = new moment(data.member_expiry);

                                    return exp.format("DD/MM/YYYY");
                                }
                            }
                        ],
                        rowClick: function(e, row) {
                            location.replace("/member/" + row.getData().id);
                        }
                    }
                );
            }, 10);
        },
        expiredMembersShow() {
            setTimeout(() => {
                this.expiredMemberTable = new Tabulator(
                    "#expired-members-table",
                    {
                        pagination: "local",
                        paginationSize: 10,
                        initialSort: [{ column: "member_expiry", dir: "desc" }],
                        data: this.expiredMember,
                        layout: "fitColumns",
                        columns: [
                            { title: "Name", field: "name" },
                            { title: "Member Level", field: "level" },
                            {
                                title: "Expired",
                                field: "member_expiry",
                                sorter: "date",
                                sorterParams: { format: "YYYY/MM/DD" },
                                formatter: function(cell) {
                                    var data = cell.getData();
                                    var exp = new moment(data.member_expiry);

                                    return exp.format("DD/MM/YYYY");
                                }
                            }
                        ],
                        rowClick: function(e, row) {
                            location.replace("/member/" + row.getData().id);
                        }
                    }
                );
            }, 10);
        },
        expiringWaiversShow() {
            setTimeout(() => {
                this.expiringWaiversTable = new Tabulator(
                    "#expiring-waivers-table",
                    {
                        pagination: "local",
                        paginationSize: 10,
                        initialSort: [{ column: "expiry", dir: "desc" }],
                        data: this.expiringWaivers,
                        layout: "fitColumns",
                        columns: [
                            {
                                title: "Name",
                                field: "first_name",
                                formatter: function(cell) {
                                    var data = cell.getRow().getData();
                                    return data.member.first_name.toUpperCase() + " " + data.member.last_name.toUpperCase();
                                }
                            },
                            {
                                title: "Site",
                                field: "location",
                                formatter: (cell) => {
                                    var value = cell.getValue();
                                    return this.sitesConfig.general[value].shortName;
                                }
                            },
                            {
                                title: "Expiring",
                                field: "expiry",
                                sorter: "date",
                                sorterParams: { format: "YYYY/MM/DD" },
                                formatter: function(cell) {
                                    var data = cell.getData();
                                    var exp = new moment(data.expiry);

                                    return exp.format("DD/MM/YYYY");
                                }
                            },
                        ],
                        rowClick: function(e, row) {
                            location.replace("/member/" + row.getRow().getData().member.id);
                        }
                    }
                );
            }, 10);
        },
        expiredWaiversShow() {
            setTimeout(() => {
                this.expiredWaiversTable = new Tabulator(
                    "#expired-waivers-table",
                    {
                        pagination: "local",
                        paginationSize: 10,
                        initialSort: [{ column: "expiry", dir: "desc" }],
                        data: this.expiredWaivers,
                        layout: "fitColumns",
                        columns: [
                            {
                                title: "Name",
                                field: "first_name",
                                formatter: function(cell) {
                                    var data = cell.getRow().getData();
                                    return data.member.first_name.toUpperCase() + " " + data.member.last_name.toUpperCase();
                                }
                            },
                            {
                                title: "Site",
                                field: "location",
                                formatter: (cell) => {
                                    var value = cell.getValue();
                                    return this.sitesConfig.general[value].shortName;
                                }
                            },
                            {
                                title: "Expired",
                                field: "expiry",
                                sorter: "date",
                                sorterParams: { format: "YYYY/MM/DD" },
                                formatter: function(cell) {
                                    var data = cell.getData();
                                    var exp = new moment(data.expiry);

                                    return exp.format("DD/MM/YYYY");
                                }
                            },
                        ],
                        rowClick: function(e, row) {
                            location.replace("/member/" + row.getRow().getData().member.id);
                        }
                    }
                );
            }, 10);
        },
        jailUserShow() {
            setTimeout(() => {
                this.jailUsersTable = new Tabulator(
                    "#jail-users-table",
                    {
                        pagination: "local",
                        paginationSize: 10,
                        initialSort: [{ column: "no_show_count", dir: "desc" }],
                        data: this.jailUsers,
                        layout: "fitColumns",
                        columns: [
                            {
                                title: "Name",
                                field: "name",
                            },
                            {
                                title: "No Show Count",
                                field: "no_show_count",
                            },
                        ],
                        rowClick: function(e, row) {
                            location.replace("/member/" + row.getData().id);
                        }
                    }
                );
            }, 10);
        },
        noShowUsersShow() {
            setTimeout(() => {
                this.noShowUsersTable = new Tabulator(
                    "#no-show-table",
                    {
                        pagination: "local",
                        paginationSize: 10,
                        initialSort: [{ column: "no_show_count", dir: "desc" }],
                        data: this.noShowUsers,
                        layout: "fitColumns",
                        columns: [
                            {
                                title: "Name",
                                field: "name",
                            },
                            {
                                title: "No Show Count",
                                field: "no_show_count",
                            },
                        ],
                        rowClick: function(e, row) {
                            location.replace("/member/" + row.getData().id);
                        }
                    }
                );
            }, 10);
        },
    },
    mounted() {
        axios
            .get("/metrics?metric=plays")
            .then(result => {
                this.lifeTimeBookings = result.data;
            })
            .catch(err => {
                console.error(err);
            });
        axios
            .get("/metrics?metric=bookings")
            .then(result => {
                this.totalFutureBookings = result.data;
            })
            .catch(err => {
                console.error(err);
            });
        axios
            .get("/metrics?metric=members")
            .then(result => {
                this.totalMembers = result.data;
            })
            .catch(err => {
                console.error(err);
            });
        axios
            .get("/metrics?metric=rentals")
            .then(result => {
                this.totalRentals = result.data;
            })
            .catch(err => {
                console.error(err);
            });
        axios.get(this.$routes.route('metrics'), {
            params: {
                metric: 'ratio'
            }
        }).then(result => {
            this.memberRatio = result.data;
        }).catch(err => {
            console.error(err);
        });
        axios.get(this.$routes.route('metrics'), {  params: { metric: 'no-ukara' } })
            .then(result => {
                this.noUkara = result.data;
        //         axios
        //             .get("/metrics?metric=ukara-expiring")
        //             .then(result => {
        //                 this.expUkara = result.data;
        //             })
        //             .catch(err => {
        //                 console.error(err);
        //             });
            })
            .catch(err => {
                console.error(err);
            });
        axios.get(this.$routes.route('metrics'), {  params: { metric: 'unverified' } })
            .then(result => {
                this.unverifiedEmails = result.data;
            })
            .catch(err => {
                console.error(err);
            });
        axios.get(this.$routes.route('metrics'), {  params: { metric: 'waiver-required' } })
            .then(result => {
                this.waiverRequired = result.data;
            })
            .catch(err => {
                console.error(err);
            });
        axios.get(this.$routes.route('metrics'), {  params: { metric: 'in-jail' } })
            .then(result => {
                this.jailUsers = result.data;
            })
            .catch(err => {
                console.error(err);
            });
        axios.get(this.$routes.route('metrics'), {  params: { metric: 'no-shows' } })
            .then(result => {
                this.noShowUsers = result.data;
            })
            .catch(err => {
                console.error(err);
            });
        axios.get(this.$routes.route('seenNotes.unseen'))
            .then(result => {
                this.unseenNoteCount = result.data.unseenNotesCount;
                this.unseenNoteBookings = result.data.unseenNotes;
            })
            .catch(err => {
                console.error(err);
            });
        // axios
        //     .get("/metrics?metric=member-expiring")
        //     .then(result => {
        //         this.expiringMember = result.data;
        //         axios
        //             .get("/metrics?metric=member-expired")
        //             .then(result => {
        //                 this.expiredMember = result.data;
        //             })
        //             .catch(err => {
        //                 console.error(err);
        //             });
        //     })
        //     .catch(err => {
        //         console.error(err);
        //     });
        // axios
        //     .get("/metrics?metric=expiring-waivers")
        //     .then(result => {
        //         this.expiringWaivers = result.data;
        //         axios
        //             .get("/metrics?metric=expired-waivers")
        //             .then(result => {
        //                 this.expiredWaivers = result.data;
        //             })
        //             .catch(err => {
        //                 console.error(err);
        //             });
        //     })
        //     .catch(err => {
        //         console.error(err);
        //     });
        if(! /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            axios.get(this.$routes.route('metrics.monthlyIncome'))
                .then(result => {
                    this.chartData = result.data;
                    setTimeout(() => {
                        var incomeChart = this.$refs.incomeChart;
                        let myChart = new Bar(incomeChart, {
                            type: "bar",
                            data: this.chartData,
                            options: {
                                barValueSpacing: 10,
                                scales: {
                                    yAxes: [
                                        {
                                            ticks: {
                                                beginAtZero: true
                                            }
                                        }
                                    ]
                                }
                            }
                        });
                    }, 100);
                })
                .catch(err => {});

            axios.get(this.$routes.route('metrics.monthlyPlayers'))
                .then(result => {
                    this.playerData = result.data;
                    setTimeout(() => {
                        var playerChart = this.$refs.playerChart;
                        let myChart = new Bar(playerChart, {
                            type: "bar",
                            data: this.playerData,
                            options: {
                                barValueSpacing: 10,
                                scales: {
                                    yAxes: [
                                        {
                                            ticks: {
                                                beginAtZero: true
                                            }
                                        }
                                    ]
                                }
                            }
                        });
                    }, 100);
                })
                .catch(err => {});
        }
    }
};
</script>